var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 30,
    viewBox: "0 0 17 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07023 28.5152C1.80523 29.2502 2.99023 29.2502 3.72523 28.5152L16.1902 16.0502C16.7752 15.4652 16.7752 14.5202 16.1902 13.9352L3.72523 1.4702C2.99023 0.735195 1.80523 0.735195 1.07023 1.4702C0.335229 2.2052 0.335229 3.3902 1.07023 4.1252L11.9302 15.0002L1.05523 25.8752C0.335229 26.5952 0.335229 27.7952 1.07023 28.5152Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselRightArrow);
export default __webpack_public_path__ + "static/media/carouselRightArrow.1202bdb6809ce5e3e4ffbfac05f83426.svg";
export { ForwardRef as ReactComponent };